  // animation.js - Slide Animation
  const SlideAnim = {
    stop(element) {
      if (element._slideTimer) {
        clearTimeout(element._slideTimer);
        element._slideTimer = null;
      }

      element._isAnimating = false;
      const computedStyle = window.getComputedStyle(element);
      const currentHeight = element.offsetHeight;
      const currentPaddingTop = parseFloat(computedStyle.paddingTop);
      const currentPaddingBottom = parseFloat(computedStyle.paddingBottom);

      element.style.transition = "";
      element.style.height = `${currentHeight}px`;
      element.style.paddingTop = `${currentPaddingTop}px`;
      element.style.paddingBottom = `${currentPaddingBottom}px`;
      element.style.overflow = "hidden";
    },

    down(element, duration = 300) {
      this.stop(element);
      element._isAnimating = true;
      element.style.display = "block";
      const style = window.getComputedStyle(element);
      const targetHeight = element.scrollHeight;
      const targetPaddingTop = parseFloat(style.paddingTop);
      const targetPaddingBottom = parseFloat(style.paddingBottom);

      element.style.transition = `height ${duration}ms ease, padding ${duration}ms ease`;
      requestAnimationFrame(() => {
        element.style.height = `${targetHeight}px`;
        element.style.paddingTop = `${targetPaddingTop}px`;
        element.style.paddingBottom = `${targetPaddingBottom}px`;
      });

      element._slideTimer = setTimeout(() => {
        element.style.removeProperty("height");
        element.style.removeProperty("padding-top");
        element.style.removeProperty("padding-bottom");
        element.style.removeProperty("transition");
        element.style.removeProperty("overflow");
        element._slideTimer = null;
        element._isAnimating = false;
      }, duration);
    },

    up(element, duration = 300) {
      this.stop(element);
      element._isAnimating = true;
      const currentHeight = element.offsetHeight;
      const style = window.getComputedStyle(element);
      const paddingTop = parseFloat(style.paddingTop);
      const paddingBottom = parseFloat(style.paddingBottom);

      element.style.height = `${currentHeight}px`;
      element.style.paddingTop = `${paddingTop}px`;
      element.style.paddingBottom = `${paddingBottom}px`;
      element.style.transition = `height ${duration}ms ease, padding ${duration}ms ease`;
      element.offsetHeight;

      requestAnimationFrame(() => {
        element.style.height = "0px";
        element.style.paddingTop = "0px";
        element.style.paddingBottom = "0px";
      });

      element._slideTimer = setTimeout(() => {
        element.style.display = "none";
        element.style.removeProperty("height");
        element.style.removeProperty("padding-top");
        element.style.removeProperty("padding-bottom");
        element.style.removeProperty("transition");
        element.style.removeProperty("overflow");
        element._slideTimer = null;
        element._isAnimating = false;
      }, duration);
    },

    toggle(element, duration = 300) {
      const display = window.getComputedStyle(element).display;
      if (display === "none" || element.offsetHeight === 0) {
        this.down(element, duration);
      } else {
        this.up(element, duration);
      }
    },
  };

  // debounce.js - Debounce Function
  const debounce = (func, wait = 150) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };

  // Intersection Observer
const wowoObserver = new IntersectionObserver(
  (entries, obs) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      requestAnimationFrame(() => {
        entry.target.classList.add("animated");
      });

      obs.unobserve(entry.target);
    });
  },
  {
    rootMargin: "0px 0px -10% 0px",
    threshold: 0.15,
  }
);

  let allItems;
  // functions
  const AppFunctions = {
    swiper() {
      document.querySelectorAll(".shop-brands-wrapper .swiper").forEach((slider) => {
        new Swiper(slider, {
          slidesPerView: "auto",
          freeMode: {
            enabled: true,
            momentum: true,
            momentumRatio: 0.2,
            momentumBounce: true,
            momentumBounceRatio: 0.2,
            sticky: true,
          },
          spaceBetween: 15,
          grabCursor: true,
          touchEventsTarget: "container",
          touchStartPreventDefault: true,
          mousewheel: {
            forceToAxis: true,
            thresholdDelta: 15,
            sensitivity: 0.8,
            eventsTarget: "container",
          },
          simulateTouch: true,
          touchRatio: 1,
          keyboard: {
            enabled: true,
          },

          breakpoints: {
            991: {
              spaceBetween: 24,
            },
          },
        });
      });

      document.querySelectorAll(".re-bound-items .swiper").forEach((slider) => {
        new Swiper(slider, {
          slidesPerView: "auto",
          freeMode: {
            enabled: true,
            momentum: true,
            momentumRatio: 0.2,
            momentumBounce: true,
            momentumBounceRatio: 0.2,
            sticky: true,
          },
          spaceBetween: 13,
          grabCursor: true,
          touchEventsTarget: "container",
          touchStartPreventDefault: true,
          mousewheel: {
            forceToAxis: true,
            thresholdDelta: 15,
            sensitivity: 0.8,
            eventsTarget: "container",
          },
          simulateTouch: true,
          touchRatio: 1,
          keyboard: {
            enabled: true,
          },

          breakpoints: {
            1200: { spaceBetween: 24 },
          },
        });
      });
      document.querySelectorAll(".product-styles .swiper").forEach((slider) => {
        new Swiper(slider, {
          slidesPerView: "auto",
          freeMode: {
            enabled: true,
            momentum: true,
            momentumRatio: 0.2,
            momentumBounce: true,
            momentumBounceRatio: 0.2,
            sticky: true,
          },
          spaceBetween: 12,
          grabCursor: true,
          touchEventsTarget: "container",
          touchStartPreventDefault: true,
          mousewheel: {
            forceToAxis: true,
            thresholdDelta: 15,
            sensitivity: 0.8,
            eventsTarget: "container",
          },
          simulateTouch: true,
          touchRatio: 1,
          keyboard: {
            enabled: true,
          },
          breakpoints: {
            1200: {
              spaceBetween: 24,
            },
          },
        });
      });
      document.querySelectorAll(".product-cards.swiper").forEach((slider) => {
        new Swiper(slider, {
          slidesPerView: "auto",
          freeMode: {
            enabled: true,
            momentum: true,
            momentumRatio: 0.2,
            momentumBounce: true,
            momentumBounceRatio: 0.2,
            sticky: true,
          },
          spaceBetween: 11,
          grabCursor: true,
          touchEventsTarget: "container",
          touchStartPreventDefault: true,
          mousewheel: {
            forceToAxis: true,
            thresholdDelta: 15,
            sensitivity: 0.8,
            eventsTarget: "container",
          },
          simulateTouch: true,
          touchRatio: 1,
          keyboard: {
            enabled: true,
          },

          breakpoints: {
            1200: { spaceBetween: 16, slidesPerView: "3" },
          },
        });
      });
         document.querySelectorAll(".product-lists:not(.no-slide) .product-items.swiper").forEach((slider) => {
      new Swiper(slider, {
        slidesPerView: "auto",
        freeMode: {
          enabled: true,
          momentum: true,
          momentumRatio: 0.2,
          momentumBounce: true,
          momentumBounceRatio: 0.2,
          sticky: true,
        },
        spaceBetween: 12,
        grabCursor: true,
        touchEventsTarget: "container",
        touchStartPreventDefault: true,
        mousewheel: {
          forceToAxis: true,
          thresholdDelta: 15,
          sensitivity: 0.8,
          eventsTarget: "container",
        },
        simulateTouch: true,
        touchRatio: 1,
        keyboard: {
          enabled: true,
        },

        breakpoints: {
          1200: {
            spaceBetween: 16,
          },
        },
      });
    });
      document.querySelectorAll(".quick-view-swiper .swiper").forEach((slider) => {
        const previewMount = slider.closest(".product-lists.no-slide");
        let slidesPerView = previewMount ? "auto" : "3";

        const breakpointsSetting = {
          1200: {
            spaceBetween: 6,
          },
        };

        if (!previewMount) {
          breakpointsSetting[1200].slidesPerView = 4;
        }

        const arrowRight = slider.parentElement.querySelector(".swiper-amount .swiper-arrow");

        new Swiper(slider, {
          slidesPerView: "auto",
          nested: true,
          freeMode: {
            enabled: true,
            momentum: true,
            momentumRatio: 0.2,
            momentumBounce: true,
            momentumBounceRatio: 0.2,
            sticky: true,
          },
          spaceBetween: 5,
          grabCursor: true,
          touchEventsTarget: "container",
          touchStartPreventDefault: true,
          mousewheel: {
            forceToAxis: true,
            thresholdDelta: 15,
            sensitivity: 0.8,
            eventsTarget: "container",
          },
          simulateTouch: true,
          touchRatio: 1,
          keyboard: {
            enabled: true,
          },
          navigation: {
            nextEl: arrowRight,
          },
          // breakpoints: breakpointsSetting,
        });
        const images = slider.querySelectorAll(".img");
        images.forEach((item) => {
          item.addEventListener("click", function () {
            const quickView = item.closest(".quick-view-swiper");
            const slides = quickView.querySelectorAll(".swiper-slide");

            slides.forEach((slide) => slide.classList.remove("is-active"));

            item.parentElement.classList.add("is-active");

            const src = item.getAttribute("data-image");
            const targetImg = item.closest(".item")?.querySelector(".image img");
            if (targetImg && src) targetImg.src = src;

            const color = item.querySelector("img")?.getAttribute("alt")?.trim();
            if (!color) return;
            
            const quickAddWrapper = item.closest(".item")?.querySelector(".quick-add-cart");
            const labels = quickAddWrapper.querySelectorAll(".size-label");
            labels.forEach((label) => {
              const colors =
                label
                  .getAttribute("data-available-colors")
                  ?.split(",")
                  .map((c) => c.trim().toLowerCase()) || [];

                
              if (!colors.includes(color.toLowerCase())) {
                label.classList.add("disabled");
              } else {
                label.classList.remove("disabled");
              }
            });
          });
        });
      });
      document.querySelectorAll(".quick-view-swiper").forEach((item) => {
        const swipers = item.querySelectorAll(".swiper-slide");
        const countElement = item.querySelector(".swiper-amount");
        const spanElement = countElement?.querySelector("span");

        if (countElement && spanElement) {
          const shouldShowCount = swipers.length > 4;
          countElement.classList.toggle("active", shouldShowCount);
          spanElement.textContent = shouldShowCount ? `+${swipers.length - 4}` : "+4";
        }

        item.addEventListener("click", (e) => {
          e.stopPropagation();
          e.preventDefault();
        });
      });

      const swiperInstances = {
        logo: null,
        product: null,
        variety: null,
        cards: null,
      };

      const cleanSwiperStyles = (container) => {
        if (!container) return;
        container.querySelectorAll(".swiper-slide").forEach((slide) => {
          slide.style.width = "";
          slide.style.transform = "";
        });
        container.classList.remove("swiper-initialized");
      };

      function initSlickForBreakpoint() {
        const varietyEls = document.querySelectorAll(".product-details .product-images");
        const w = window.innerWidth;

        varietyEls.forEach((varietyEl) => {
          const slides = varietyEl.querySelectorAll(".swiper-slide");
          const nextEl = varietyEl.parentElement.querySelector(".swiper-next");
          const prevEl = varietyEl.parentElement.querySelector(".swiper-prev");

          if (slides.length <= 1) {
            nextEl?.classList.add("hidden");
            prevEl?.classList.add("hidden");

            if (varietyEl.swiper) {
              varietyEl.swiper.destroy(true, true);
              cleanSwiperStyles(varietyEl);
              swiperInstances.variety = null;
            }
            return;
          } else {
            nextEl?.classList.remove("hidden");
            prevEl?.classList.remove("hidden");
          }

          if (w <= 991) {
            if (!varietyEl.swiper) {
              swiperInstances.variety = new Swiper(varietyEl, {
                slidesPerView: "1",
                speed: 500,
                autoplay: false,
                spaceBetween: 8,
                grabCursor: true,
                touchEventsTarget: "container",
                touchStartPreventDefault: true,
                mousewheel: {
                  forceToAxis: true,
                  thresholdDelta: 15,
                  sensitivity: 0.8,
                  eventsTarget: "container",
                },
                simulateTouch: true,
                touchRatio: 1,
                keyboard: {
                  enabled: true,
                },
                navigation: {
                  nextEl: nextEl,
                  prevEl: prevEl,
                },
              });
            }
          } else if (varietyEl.swiper) {
            varietyEl.swiper.destroy(true, true);
            cleanSwiperStyles(varietyEl);
            swiperInstances.variety = null;
          }
        });

        const varietyCartSwiper = document.querySelector(".cart-prodcuts-wrapper .swiper");
        if (varietyCartSwiper) {
          if (w <= 767) {
            if (!varietyCartSwiper.swiper) {
              swiperInstances.cards = new Swiper(varietyCartSwiper, {
                slidesPerView: "auto",
                speed: 500,
                autoplay: false,
                // loop: true,
                // loopAdditionalSlides:2,
                spaceBetween: 8,
                // slideToClickedSlide: true,
                grabCursor: true,
                touchEventsTarget: "container",
                touchStartPreventDefault: true,
                spaceBetween: 15,
                mousewheel: {
                  forceToAxis: true,
                  thresholdDelta: 15,
                  sensitivity: 0.8,
                  eventsTarget: "container",
                },
                simulateTouch: true,
                touchRatio: 1,
                keyboard: {
                  enabled: true,
                },
              });
            }
          } else if (varietyCartSwiper.swiper) {
            varietyCartSwiper.swiper.destroy(true, true);
            cleanSwiperStyles(varietyCartSwiper);
            swiperInstances.cards = null;
          }
        }
      }
      initSlickForBreakpoint();
      window.addEventListener("resize", function () {
        debounce(initSlickForBreakpoint(), 150);
      });

      // document.querySelectorAll(".cart-empty-slider .swiper").forEach((swiper) => {
      //   new Swiper(swiper, {
      //     slidesPerView: "1",
      //     speed: 500,
      //     loop: true,
      //     // loopAdditionalSlides:2,
      //     spaceBetween: 8,
      //     // slideToClickedSlide: true,
      //     autoplay: true,
      //     grabCursor: true,
      //     touchEventsTarget: "container",
      //     touchStartPreventDefault: true,
      //     mousewheel: {
      //       forceToAxis: true,
      //       thresholdDelta: 15,
      //       sensitivity: 0.8,
      //       eventsTarget: "container",
      //     },
      //     simulateTouch: true,
      //     touchRatio: 1,
      //     keyboard: {
      //       enabled: true,
      //     },
      //     on: {
      //       // slideChangeTransitionStart: function () {
      //       //   this.slides.forEach((slide) => {
      //       //     slide.classList.remove("scale-animation");
      //       //   });
      //       // },
      //       // slideChangeTransitionEnd: function () {
      //       //   const activeSlide = this.slides[this.activeIndex];
      //       //   if (activeSlide) {
      //       //     activeSlide.classList.add("scale-animation");
      //       //   }
      //       // },
      //     },
      //   });
      // });
    },

    click() {
  
      // body overflow-hidden
      const bodyEle = document.body;
      const htmlEle = document.documentElement;
      // hamburger
      document.querySelector(".header__hamburger").addEventListener("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
        document.querySelector(".header__nav-menu").classList.add("is-active");
        bodyEle.classList.add("overflow-hidden");
        htmlEle.classList.add("overflow-hidden");
      });
      // child menu
      document.addEventListener("click", function (e) {
        const target = e.target;

        const menuItem = target.closest(".menu-item");
        if(window.innerWidth <= 991 && target.nextElementSibling?.classList.contains('menu-wrapper')) {
          e.preventDefault();
        }
        if (menuItem && window.innerWidth < 991) {
          const menuWrapper = menuItem.querySelector(".menu-wrapper");
          if (menuWrapper) menuWrapper.classList.add("active");
        }

        const brandGroup = target.closest(".brand-group");
        if (brandGroup && window.innerWidth < 991) {
          const ul = brandGroup.querySelector("ul");
          if (ul) ul.classList.add("active");
        }

        if (window.innerWidth < 991 && target.matches(".brands .brand-group-wrapper h3")) {
          const brandsItem = target.closest(".menu-item.brands");
          if (brandsItem) {
            const brandGroups = brandsItem.querySelector(".brand-groups");
            if (brandGroups) brandGroups.classList.add("active");
          }
        }
      });

      // humburger close
      document.querySelector(".menu-top-show-m .icon-close-menu")?.addEventListener("click", () => {
        const menu = document.querySelector(".header__nav-menu");
        const bodyEle = document.body;
        const htmlEle = document.documentElement;

        const getHelpItem = menu.querySelector(".menu-item.get-helps .menu-wrapper.active");
        const returnItem = menu.querySelector(".menu-item.returns .menu-wrapper.active");
        const getHelpLink = document.querySelector(".header__top-wrapper .get-help");
        const returnLink = document.querySelector(".header__top-wrapper .return");

        const hasFlag = getHelpLink?.classList.contains("flag") || returnLink?.classList.contains("flag");

        if (hasFlag) {
          [getHelpItem, returnItem].forEach((item) => item?.classList.remove("active"));
          [getHelpLink, returnLink].forEach((link) => link?.classList.remove("flag"));

          menu.classList.remove("is-active");
          bodyEle.classList.remove("overflow-hidden");
          htmlEle.classList.remove("overflow-hidden");
          return;
        }

        const activeSubMenus = menu.querySelectorAll(".menu-wrapper .brand-group ul.active");

        if (activeSubMenus.length > 0) {
          activeSubMenus.forEach((ul) => ul.classList.remove("active"));
          return;
        }

        const activeWrappers = menu.querySelectorAll(".menu-wrapper.active");
        if (activeWrappers.length > 0) {
          activeWrappers.forEach((wrapper) => {
            wrapper.classList.remove("active");
            wrapper.querySelector(".brand-groups.active")?.classList.remove("active");
          });
          return;
        }

        menu.classList.remove("is-active");
        bodyEle.classList.remove("overflow-hidden");
        htmlEle.classList.remove("overflow-hidden");
      });

      document.body.addEventListener("click", function (e) {
        const backTop = e.target.closest(".back-top");
        if (backTop) {
          e.stopPropagation();
          const parent = backTop.parentElement;
          if (parent) {
            parent.classList.remove("active");
          }
        }
      });
      document.querySelector(".get-help").addEventListener("click", (e) => {
        e.preventDefault();
        document.querySelector(".header__nav-menu").classList.add("is-active");
        document.querySelector(".menu-item.get-helps .menu-wrapper").classList.add("active");
        document.querySelector(".get-help").classList.add("flag");
        bodyEle.classList.add("overflow-hidden");
        htmlEle.classList.add("overflow-hidden");
      });

      document.querySelector(".return").addEventListener("click", (e) => {
        e.preventDefault();
        document.querySelector(".header__nav-menu").classList.add("is-active");
        document.querySelector(".menu-item.returns .menu-wrapper").classList.add("active");
        document.querySelector(".return").classList.add("flag");
        bodyEle.classList.add("overflow-hidden");
        htmlEle.classList.add("overflow-hidden");
      });

    // search
    const searchContainer = document.querySelector(".header__nav-search");
    const searchInput = document.querySelector(".header__nav-search .search-input");
    const bodyMask = document.querySelector("body");

    if (searchContainer && searchInput) {
      searchInput.addEventListener("click", function () {
        searchContainer.classList.add("active");
        bodyMask.classList.add("mask-active");
        bodyEle.classList.add("overflow-hidden");
      });
      searchInput.addEventListener("keydown", function (e) {
        if (e.key === "Tab") {
          e.preventDefault();
          document.querySelector(".icon-account").focus();
        }
      });
      const checkAndClose = () => {
        const value = searchInput.value.trim();
        if (value === "") {
          searchContainer.classList.remove("active");
          bodyMask.classList.remove("mask-active");
          bodyEle.classList.remove("overflow-hidden");
        }
      };

      const searchFormFooter = document.querySelector(".predictive-search-form__footer");

      searchInput.addEventListener("blur", checkAndClose);

      searchInput.addEventListener("input", function () {
        const value = searchInput.value.trim();
        if (value !== "") {
          searchFormFooter.classList.add("active");
        } else {
          searchFormFooter.classList.remove("active");
        }
      });

      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && searchContainer.classList.contains("active")) {
          searchContainer.classList.remove("active");
          searchInput.blur();
          bodyMask.classList.remove("mask-active");
          bodyEle.classList.add("overflow-hidden");
        }
        if (e.key === "Escape" && document.querySelector(".quick-view-pop-up").classList.contains("active")) {
          document.querySelector(".quick-view-pop-up").classList.remove("is-show");
        }
      });
    }

    document.querySelector(".mobile-search-btn")?.addEventListener("click", function () {
      document.querySelector(".search-modal").classList.add("active");
      bodyEle.classList.add("overflow-hidden");
   
    });

    document.body.addEventListener("click", function (e) {
      const isResetBtn = e.target.closest(".predictive-search__reset-button");
      const isInsideSearch = e.target.closest(".mobile-search-btn");
      const isInsideModalContent = e.target.closest(".search-modal__content");

      if (isResetBtn || (!isInsideSearch && !isInsideModalContent)) {
        document.querySelector(".search-modal")?.classList.remove("active");
        bodyEle.classList.remove("overflow-hidden");
        bodyMask?.classList.remove("mask-active");
        document.querySelector("#predictive-search-results")?.setAttribute("aria-label", "");
      }
    });
    function clearSearch() {
      if (!searchInput) return;

      searchInput.value = "";

      ["input", "change"].forEach((eventType) => {
        const event = new Event(eventType, { bubbles: true });
        searchInput.dispatchEvent(event);
      });

      searchContainer?.classList.remove("active");
      bodyEle.classList.remove("overflow-hidden");
      bodyMask?.classList.remove("mask-active");
      bodyEle.classList.remove("overflow-hidden");
      document.querySelector("#predictive-search-results")?.setAttribute("aria-label", "");
    }

    document.body.addEventListener("click", function (e) {
      const isResetBtn = e.target.closest(".predictive-search__reset-button");
      const isInsideSearch = e.target.closest(".header__nav-search");
      const isInsideModalContent = e.target.closest(".search-modal__content");

      if (isResetBtn || !isInsideSearch) {
        clearSearch();
      }
    });

    const feedBackPopUp = document.querySelector(".feed-back-pop-up");

    document.body.addEventListener("click", function (e) {
      const item = e.target.closest(".feed-back");
      if (!item) return;
      if (feedBackPopUp) {
        feedBackPopUp.classList.add("is-active");
        bodyEle.classList.add("overflow-hidden");
        htmlEle.classList.add("overflow-hidden");
      }
    });

      // pop up
      document.body.addEventListener("click", (e) => {
        const sizeChartPopup = document.querySelector(".size-chart-pop-up");
        const closeIcon = document.querySelector(".icon-close");
        const quickViewPopup = document.querySelector(".quick-view-pop-up");

        if (e.target.closest(".size-chart")) {
          e.preventDefault();
          AppFunctions.simpleBar();
          if (sizeChartPopup) sizeChartPopup.classList.add("is-active");
          if (closeIcon) closeIcon.classList.add("is-active");
          bodyEle.classList.add("overflow-hidden");
          htmlEle.classList.add("overflow-hidden");
        }

        if (e.target.closest(".icon-close")) {
          if (sizeChartPopup) sizeChartPopup.classList.remove("is-active");

          if (!quickViewPopup || !quickViewPopup.classList.contains("is-show")) {
            bodyEle.classList.remove("overflow-hidden");
            htmlEle.classList.remove("overflow-hidden");
          }
        }

        if (e.target.closest(".see-more")) {
          e.preventDefault();
          e.stopPropagation();
          document.querySelector(".condition-codes-pop-up ").classList.add("active");
          bodyEle.classList.add("overflow-hidden");
          htmlEle.classList.add("overflow-hidden");
        }
      });

      document.querySelector(".condition-codes-pop-up .icon-close")?.addEventListener("click", function () {
        document.querySelector(".condition-codes-pop-up ").classList.remove("active");
        bodyEle.classList.remove("overflow-hidden");
        htmlEle.classList.remove("overflow-hidden");
      });
      // accordions
           if (window.innerWidth < 575) {
  const first = document.querySelector(".accordion");
  const drop = first?.querySelector(".accordion-drop-box");
  first?.classList.add("active");
  if(drop)  SlideAnim.down(drop);
   }
      document.addEventListener("click", (e) => {
        const header = e.target.closest(".accordion h3");
        if (!header) return;

        const element = header.closest(".accordion");
        if (!element) return;

        const dropBox = element.querySelector(".accordion-drop-box");
        if (!dropBox) return;

        const isActive = element.classList.contains("active");

        document.querySelectorAll(".accordion").forEach((el) => {
          const box = el.querySelector(".accordion-drop-box");
          if (!box) return;

          if (el !== element) {
            el.classList.remove("active");
            SlideAnim.up(box);
          }
        });

        if (isActive) {
          element.classList.remove("active");
          SlideAnim.up(dropBox);
        } else {
          element.classList.add("active");
          SlideAnim.down(dropBox);
        }
      });

      document.querySelectorAll(".faq-wrapper").forEach((Items) => {
        const faqItems = Items.querySelectorAll(".faq-item");
        faqItems.forEach((item) => {
          const header = item.querySelector(".faq-item--title");
          const dropBox = item.querySelector(".faq-item--drop-box");

          header.addEventListener("click", () => {
            const isActive = item.classList.contains("active");

            document.querySelectorAll(".faq-item").forEach((el) => {
              el.classList.remove("active");
              SlideAnim.up(el.querySelector(".faq-item--drop-box"));
            });

            if (!isActive) {
              item.classList.add("active");
              SlideAnim.down(dropBox);
            }
          });
        });
      });
      const isTri = document.querySelector(".is-tri");
      const isFour = document.querySelector(".is-four");

      isTri?.addEventListener("click", function () {
        bodyEle.classList.add("is-tri");
        isFour.classList.remove("active");
      });

      isFour?.addEventListener("click", function () {
        bodyEle.classList.remove("is-tri");
        isFour.classList.add("active");
      });
      document.addEventListener("click", function (e) {
        const item = e.target.closest(".variant-option__button-label--has-swatch");
        if (!item) return;

        const input = item.querySelector("input");
        if (!input) return;

        const dataVal = input.value;

        document.querySelectorAll(".variant-media-group").forEach((group) => {
          group.classList.toggle("active", group.getAttribute("data-color") === dataVal);
        });
      });

      // scroll to reviews

      const jdviews = document.querySelector(".product-details__info .jdgm-preview-badge");

      if (jdviews) {
        jdviews.addEventListener("click", function () {
          const header = document.querySelector(".header");
          const target = document.querySelector(".jdgm-all-reviews-text");

          if (!header || !target) return;

          const headerHeight = header.offsetHeight;
          const targetTop = target.getBoundingClientRect().top + window.scrollY;

          window.scrollTo({
            top: targetTop - headerHeight,
            behavior: "smooth",
          });
        });
      }
      if (!localStorage.getItem("popupShown")) {
        setTimeout(() => {
          const popup = document.querySelector(".discount-pop-up");
          if (popup) {
            popup.classList.add("is-active");
            localStorage.setItem("popupShown", "true");

            document.addEventListener("click", function closePopup(e) {
              if (popup && popup.classList.contains("is-active")) {
                const popUpContent = popup.querySelector(".content");

                if (popUpContent && !popUpContent.contains(e.target)) {
                  popup.classList.remove("is-active");
                  document.removeEventListener("click", closePopup);
                }
              }
            });
          }
        }, 1000);
      }

      // filter

      // document.addEventListener('click', function (e) {
      //   const clickedSummary = e.target.closest('.facets__item .facets__summary');
      //   const currentItem = clickedSummary.closest('.facets__item');
      //   const currentInputs = currentItem.querySelector('.facets__inputs');
      //   const isOpen = currentItem.classList.contains('active');

      //   document.querySelectorAll('.facets__item').forEach((item) => {
      //     const inputs = item.querySelector('.facets__inputs');
      //     if (item !== currentItem) {
      //       if (inputs) SlideAnim.up(inputs);
      //     }
      //   });

      //   if (!isOpen) {
      //     currentItem.classList.add('active');
      //     if (currentInputs) SlideAnim.down(currentInputs);
      //   } else {
      //     currentItem.classList.remove('active');
      //     if (currentInputs) SlideAnim.up(currentInputs);
      //   }
      // });

      // footer select language
      document.body.addEventListener("click", function (e) {
        const selectInput = e.target.closest(".select-input");
        if (selectInput) {
          e.stopPropagation();
          selectInput.classList.toggle("active");
          const langList = selectInput.querySelector("ul");
          if (typeof SlideAnim !== "undefined" && SlideAnim.toggle) {
            SlideAnim.toggle(langList);
          } else {
            langList.style.display = langList.style.display === "none" ? "block" : "none";
          }
        }
        const li = e.target.closest(".select-input li");
        if (li) {
          e.stopPropagation();
          const a = li.querySelector("a");
          if (a) {
            const langItemText = a.textContent.trim();
            const currLang = document.querySelector(".select-language .current-lang");
            if (currLang) {
              currLang.textContent = langItemText;
            }
          }

          const selectInputParent = li.closest(".select-input");
          if (selectInputParent) {
            selectInputParent.classList.remove("active");
            const langList = selectInputParent.querySelector("ul");
            if (typeof SlideAnim !== "undefined" && SlideAnim.slideUp) {
              SlideAnim.slideUp(langList, 300);
            } else {
              langList.style.display = "none";
            }
          }
        }
      });
      document.querySelector(".select-state-show-m .current-state").addEventListener("click", function () {
        this.classList.toggle("active");
        SlideAnim.toggle(this.parentElement.querySelector("ul"));
      });
      document.querySelectorAll(".select-state-show-m li").forEach((Item) => {
        const currentState = Item.closest(".select-state-show-m").querySelector(".current-state");
        Item.addEventListener("click", () => {
          const ItemContent = Item.textContent;
          currentState.querySelector("span").textContent = ItemContent;
          currentState.classList.remove("active");
          SlideAnim.up(Item.parentElement);
        });
      });
      // sticky bar tigger click
      document.querySelectorAll(".select-opt").forEach((item) => {
        const input = item.querySelector(".input");
        if (input.querySelector("span").textContent == "") {
          item.classList.add("hidden");
        }
      });
      document.addEventListener("click", function (e) {
        const selectOpt = e.target.closest(".select-opt");
        if (selectOpt) {
          const selectOptions = document.querySelectorAll(".select-opt");
          const wasActive = selectOpt.classList.contains("active");
          selectOptions.forEach((opt) => opt.classList.remove("active"));
          if (!wasActive) selectOpt.classList.add("active");
        }

        const li = e.target.closest(".select-opt li");
        if (li) {
          const dataVal = li.getAttribute("data-value");
          const selectOpt = li.closest(".select-opt");
          const spanText = selectOpt.querySelector("span");

          const optionLabels = document.querySelectorAll(".variant-option__button-label");
          optionLabels.forEach((label) => {
            const inputVal = label.querySelector("input").value;
            if (dataVal === inputVal) {
              label.click();
              if (spanText) spanText.textContent = dataVal;
            }
          });
        }

        // add to cart

        // document.body.addEventListener("click", function (e) {
        //   const btn = e.target.closest(".cart-prodcuts-wrapper .btn");
        //   if (!btn) return;
        //   e.preventDefault();
        //   e.stopPropagation();
        //   const addToCartBtn = btn.parentElement?.querySelector(".product-addtocart-form .add-to-cart-button");
        //   addToCartBtn?.click();
        // });
      });

      document.body.addEventListener("click", function (e) {
        const target = e.target.closest(".product-add .btn");
        if (!target) return;

        const addToCartButton = document.querySelector(".product-details__info .add-to-cart-button");
        if (addToCartButton) {
          addToCartButton.click();
        }
      });
      // quick view
      document.addEventListener("click", function (e) {
        const input = e.target.closest('.size-select input[type="text"]');
        if (!input) return;

        e.preventDefault();

        const quickAddCart = input.closest(".quick-add-cart");
        //const productUrl = quickAddCart?.getAttribute("data-url");
        const productUrl = e.target.closest('[data-url]')?.getAttribute("data-url") + '&section_id=template--25690788102420__main';

        if (productUrl) {
          fetchProductHTML(productUrl)
            .then((html) => {
              const productInfoHTML = extractProductInformation(html);
              if (productInfoHTML) {
                insertIntoQuickView(productInfoHTML);
                document.querySelectorAll(".quick-view-pop-up .product-images ").forEach((slider) => {
                  const nextEl = slider.closest(".variant-media-group ").querySelector(".swiper-nav .swiper-next");
                  const prevEl = slider.closest(".variant-media-group ").querySelector(".swiper-nav .swiper-prev");
                  new Swiper(slider, {
                    slidesPerView: "1",
                    speed: 500,
                    autoplay: false,
                    spaceBetween: 8,
                    grabCursor: true,
                    touchEventsTarget: "container",
                    touchStartPreventDefault: true,
                    mousewheel: {
                      forceToAxis: true,
                      thresholdDelta: 15,
                      sensitivity: 0.8,
                      eventsTarget: "container",
                    },
                    simulateTouch: true,
                    touchRatio: 1,
                    keyboard: {
                      enabled: true,
                    },
                    navigation: {
                      nextEl: nextEl,
                      prevEl: prevEl,
                    },
                  });
                });
              }
            })
            .catch((error) => {
              console.error(error);
            });
        }
      });

      function fetchProductHTML(url) {
        return new Promise((resolve, reject) => {
          fetch(url)
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.text();
            })
            .then((html) => {
              resolve(html);
            })
            .catch((error) => {
              reject(error);
            });
        });
      }
      function extractProductInformation(html) {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        const productInfoElement = tempDiv.querySelector(".content.product-information");
        if (productInfoElement) {
          return productInfoElement.innerHTML;
        } else {
          return null;
        }
      }
      function insertIntoQuickView(htmlContent) {
        const quickViewContent = document.querySelector(".quick-view-pop-up .content");
        if (quickViewContent) {
          quickViewContent.innerHTML = htmlContent;
          const quickViewPopup = document.querySelector(".quick-view-pop-up");
          if (quickViewPopup) {
            quickViewPopup.querySelector(".product-details__info").classList.remove("wowo");
            quickViewPopup.querySelector(".product-details__images").classList.remove("wowo");
            quickViewPopup.classList.add("is-show");
            bodyEle.classList.add("overflow-hidden");
            htmlEle.classList.add("overflow-hidden");
          }
        }
      }
      //disabled
      document.body.addEventListener("click", function (e) {
        document.querySelectorAll(".select-input.active").forEach((selectInput) => {
          if (!selectInput.contains(e.target)) {
            selectInput.classList.remove("active");
            const langList = selectInput.querySelector("ul");
            if (typeof SlideAnim !== "undefined" && SlideAnim.slideUp) {
              SlideAnim.slideUp(langList, 300);
            } else {
              langList.style.display = "none";
            }
          }
        });
        if (e.target.closest(".disabled")) {
          e.stopPropagation();
          e.preventDefault();
        }
        const sizeChart = document.querySelector(".size-chart-pop-up");

        if (sizeChart && sizeChart.classList.contains("is-active")) {
          const quickViewPopup = document.querySelector(".quick-view-pop-up");

          const sizeChartContent = sizeChart.querySelector(".size-chart-wrapper");
          if (sizeChartContent && !sizeChartContent.contains(e.target) && !e.target.closest(".size-chart")) {
            sizeChart.classList.remove("is-active");

            if (!quickViewPopup || !quickViewPopup.classList.contains("is-show")) {
              bodyEle.classList.remove("overflow-hidden");
              htmlEle.classList.remove("overflow-hidden");
            }
          }
        }
        // header menu
        const headerMenu = document.querySelector(".header__nav-menu");
        const menuWrappers = document.querySelectorAll(".menu-wrapper");

        if (headerMenu && headerMenu.classList.contains("is-active")) {
          if (headerMenu && !headerMenu.contains(e.target) && !e.target.closest(".header__hamburger") && !e.target.closest(".return") && !e.target.closest(".get-help")) {
            headerMenu.classList.remove("is-active");
            menuWrappers.forEach((item) => {
              item.classList.remove("active");
              item.querySelector(".brand-groups")?.classList.remove("active");
            });
            bodyEle.classList.remove("overflow-hidden");
            htmlEle.classList.remove("overflow-hidden");
          }
        }

        const isSelectOpt = e.target.closest(".select-opt");
        const selectOpts = document.querySelectorAll(".select-opt");

        if (!isSelectOpt) {
          selectOpts.forEach((item) => {
            item.classList.remove("active");
          });
        }
        // quick view -pop up
        const quickView = document.querySelector(".quick-view-pop-up");
        if (quickView && quickView.classList.contains("is-show")) {
          const quickViewContent = quickView.querySelector(".content");
          if (quickViewContent && !quickViewContent.contains(e.target) && !e.target.closest(".size-select")) {
            quickView.classList.remove("is-show");
            bodyEle.classList.remove("overflow-hidden");
            htmlEle.classList.remove("overflow-hidden");
          }
        }

        if (feedBackPopUp && feedBackPopUp.classList.contains("is-active")) {
  
          const feedBackPopUpContent = feedBackPopUp.querySelector(".content");
          if (feedBackPopUpContent && !feedBackPopUpContent.contains(e.target) && !e.target.closest(".feed-back")) {
            feedBackPopUp.classList.remove("is-active");
            bodyEle.classList.remove("overflow-hidden");
            htmlEle.classList.remove("overflow-hidden");
          }
        }

        const conditionPopUp = document.querySelector(".condition-codes-pop-up");
        if (conditionPopUp && conditionPopUp.classList.contains("active")) {
          const conditionPopUpContent = conditionPopUp.querySelector(".content");
          if (conditionPopUpContent && !conditionPopUpContent.contains(e.target) && !e.target.closest(".see-more")) {
            conditionPopUp.classList.remove("active");
            bodyEle.classList.remove("overflow-hidden");
            htmlEle.classList.remove("overflow-hidden");
          }
        }
      });
      // footer
      document.querySelectorAll(".footer-menu .menu-item").forEach((item) => {
        const dropBox = item.querySelector(".sub-menu");

        item.addEventListener("click", function () {
          const isActive = item.classList.contains("active");
          if (window.innerWidth < 991) {
            document.querySelectorAll(".footer-menu .menu-item").forEach((el) => {
              el.classList.remove("active");
              SlideAnim.up(el.querySelector(".sub-menu"));
            });

            if (!isActive) {
              item.classList.add("active");
              SlideAnim.down(dropBox);
            }
          }
        });
      });

      // sticky bar
    },
    marquee() {
      document.querySelectorAll(".marquee3k").forEach((el) => {
        el.addEventListener("mouseenter", () => {
          Marquee3k.pauseAll();
        });
        el.addEventListener("mouseleave", () => {
          Marquee3k.playAll();
        });
      });
      Marquee3k.init({ selector: "marquee3k" });
    },
    insertElement() {
      function toTitleCase(str) {
        return str.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
      }
      function safelyGetTextContent(element, selector) {
        return element.querySelector(selector)?.textContent?.trim();
      }

      document.querySelectorAll(".nav-menu .menu-item").forEach((item) => {
        const title = safelyGetTextContent(item, "a");
        if (!title) return;
        const menuWrapper = item.querySelector(".menu-wrapper");
        if (!menuWrapper) return;

        const formattedTitle = toTitleCase(title);

        const lastChar = formattedTitle.slice(-1).toLowerCase();

        const topLevelApostrophe = lastChar === "s" ? "" : "'s";

        if (item.classList.length === 1 && item.classList.contains("menu-item")) {
          const titleEl = document.createElement("h3");
          titleEl.className = "back-top";
          titleEl.textContent = `${formattedTitle}${topLevelApostrophe}`;
          menuWrapper.prepend(titleEl);

          item.querySelectorAll(".brand-group").forEach((group) => {
            const groupTitle = safelyGetTextContent(group, "h3");
            const groupList = group.querySelector("ul");
            if (!groupTitle || !groupList) return;

            const formattedGroupTitle = toTitleCase(groupTitle);
            const groupTitleEl = document.createElement("h3");
            groupTitleEl.className = "back-top";

            const internalApostrophe = lastChar === "s" ? "'" : "'s";

            groupTitleEl.textContent = `${formattedTitle}${internalApostrophe} ${formattedGroupTitle}`;
            groupList.prepend(groupTitleEl);
          });
        } else if (item.classList.contains("brands")) {
          const groupWrapper = menuWrapper.querySelector(".brand-group-wrapper");
          if (!groupWrapper) return;

          const groups = groupWrapper.querySelector(".brand-groups");
          const groupWrapperTitleEl = groupWrapper.querySelector("h3");
          if (!groups || !groupWrapperTitleEl) return;

          const formattedGroupWrapperTitle = groupWrapperTitleEl.textContent;

          const titleEl1 = document.createElement("h3");
          titleEl1.className = "back-top";
          titleEl1.textContent = `${formattedTitle}${topLevelApostrophe}`;
          menuWrapper.prepend(titleEl1);

          const titleEl2 = document.createElement("h3");
          titleEl2.className = "back-top";

          // const internalApostrophe = lastChar === "s" ? "'" : "";
          titleEl2.textContent = ` ${formattedGroupWrapperTitle}`;
          groups.prepend(titleEl2);
        }
      });

     
    const links = document.querySelectorAll(".header__nav-wrapper a, .footer-menu a,.service-items a");

      links.forEach((a) => {
        if (a.textContent && a.textContent.includes("Feedback")) {
          a.classList.add("feed-back");
        }
      });
    },

  resizeWindow() {
    document.querySelectorAll(".product-items .item").forEach((item) => {
      const textElement = item.querySelector(".text");
      if (textElement) {
        const bottom = textElement.offsetHeight;
        item.style.setProperty("--bottom", bottom + "px");
      }
    });
    document.querySelectorAll(".product-grid__item").forEach((item) => {
      const textElement = item.querySelector(".text");
      if (textElement) {
        const bottom = textElement.offsetHeight;
        item.style.setProperty("--bottom", bottom + "px");
      }
    });
    const pageNote = document.querySelector(".page-notes");
    if (pageNote) {
      pageNote.style.setProperty("--height", pageNote.offsetHeight + "px");
    }

    
const header = document.querySelector('.header');
const headerHeight = header.offsetHeight;

document.body.style.setProperty("--header-height", headerHeight + "px");

  },


    productUpdate() {
      document.querySelectorAll(".quick-view-swiper .swiper").forEach((slider) => {
        const previewMount = slider.closest(".product-lists.no-slide");
        let slidesPerView = previewMount ? "auto" : "3";

        const breakpointsSetting = {
          1200: {
            spaceBetween: 6,
          },
        };

        if (!previewMount) {
          breakpointsSetting[1200].slidesPerView = 4;
        }

        const arrowRight = slider.parentElement.querySelector(".swiper-amount .swiper-arrow");

        new Swiper(slider, {
          slidesPerView: "auto",
          nested: true,
          freeMode: {
            enabled: true,
            momentum: true,
            momentumRatio: 0.2,
            momentumBounce: true,
            momentumBounceRatio: 0.2,
            sticky: true,
          },
          spaceBetween: 5,
          grabCursor: true,
          touchEventsTarget: "container",
          touchStartPreventDefault: true,
          mousewheel: {
            forceToAxis: true,
            thresholdDelta: 15,
            sensitivity: 0.8,
            eventsTarget: "container",
          },
          simulateTouch: true,
          touchRatio: 1,
          keyboard: {
            enabled: true,
          },
          navigation: {
            nextEl: arrowRight,
          },
          breakpoints: breakpointsSetting,
        });
        const images = slider.querySelectorAll(".img");

        images.forEach((item) => {
          item.addEventListener("click", function () {
            const quickView = item.closest(".quick-view-swiper");
            const slides = quickView.querySelectorAll(".swiper-slide");

            slides.forEach((slide) => slide.classList.remove("is-active"));

            item.parentElement.classList.add("is-active");

            const src = item.getAttribute("data-image");
            const targetImg = item.closest(".item")?.querySelector(".image img");
            if (targetImg && src) targetImg.src = src;

            const color = item.querySelector("img")?.getAttribute("alt")?.trim();
       

            if (!color) return;

            const quickAddWrapper = item.parentElement?.closest("a")?.parentElement?.querySelector(".quick-add-cart");
            if (!quickAddWrapper) return;

            const labels = quickAddWrapper.querySelectorAll(".size-label");
            labels.forEach((label) => {
              const colors =
                label
                  .getAttribute("data-available-colors")
                  ?.split(",")
                  .map((c) => c.trim().toLowerCase()) || [];

              if (!colors.includes(color.toLowerCase())) {
                label.classList.add("disabled");
              } else {
                label.classList.remove("disabled");
              }
            });

          });
        });
      });
      document.querySelectorAll(".quick-view-swiper").forEach((item) => {
        const swipers = item.querySelectorAll(".swiper-slide");
        const countElement = item.querySelector(".swiper-amount");
        const spanElement = countElement?.querySelector("span");

        if (countElement && spanElement) {
          const shouldShowCount = swipers.length > 5;
          countElement.classList.toggle("active", shouldShowCount);
          spanElement.textContent = shouldShowCount ? `+${swipers.length - 4}` : "+4";
        }

        item.addEventListener("click", (e) => {
          e.stopPropagation();
          e.preventDefault();
        });
      });
    },
    simpleBar() {
      document.querySelectorAll(".size-chart-pop-up .table-wrapper").forEach((element) => {
        new SimpleBar(element);
      });
      document.querySelectorAll(".size-chart-pop-up .content").forEach((element) => {
        new SimpleBar(element);
      });
    },
  UpdateQuickAdd() {
      document.querySelectorAll(".quick-add-cart").forEach((cart) => {
        const sizeSelect = cart.querySelector(".size-select");
        if (!sizeSelect || sizeSelect.children.length === 0) {
          cart.style.display = "none";
        } else {
          cart.style.display = "";
        }
      });
  
      const isEmpty = document.querySelector(".main-collection-grid__empty");
      if (isEmpty) {
        document.querySelector("results-list").classList.add("is-empty");
      }
    },
  scroll() {
  const header = document.querySelector(".header");
  const stickyBar = document.querySelector(".sticky-bottom-bar");
  const Pdtails = document.querySelector(".product-details__tips");
  const headerHeight = header.offsetHeight;

  let lastScrollTop = window.scrollY || 0;
  let isHeaderVisible = false;
  let isStickyBarVisible = false;

  function updateHeader() {
    const scrollTop = window.scrollY || 0;
    const scrollDirection = scrollTop > lastScrollTop ? 'down' : 'up';

    const shouldShowHeader = scrollTop > headerHeight;
    if (shouldShowHeader !== isHeaderVisible) {
      header.classList.toggle("is-show", shouldShowHeader);
      isHeaderVisible = shouldShowHeader;
    }

    const isPastHeader = scrollTop > headerHeight;
    if (isPastHeader) {
      const shouldBeSticky = scrollDirection === 'down';
      header.classList.toggle("sticky", shouldBeSticky);
    } else {
      header.classList.remove("sticky");
    }

    lastScrollTop = scrollTop;

    if (Pdtails && stickyBar) {
      const pdtailsTop = Pdtails.offsetTop;
      const shouldShowStickyBar = scrollTop > pdtailsTop;
      
      if (shouldShowStickyBar !== isStickyBarVisible) {
        stickyBar.classList.toggle("is-show", shouldShowStickyBar);
        isStickyBarVisible = shouldShowStickyBar;
      }
    }
  }

  let isScrolling;
  function throttledUpdate() {
    if (!isScrolling) {
      isScrolling = true;
      requestAnimationFrame(() => {
        updateHeader();
        isScrolling = false;
      });
    }
  }

  window.addEventListener("scroll", throttledUpdate, { passive: true });
  updateHeader();
},
lenisFun() {
  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: "vertical",
    smooth: true,
    smoothTouch: false, 
    touchMultiplier: 1.5,
    wheelMultiplier: 1.2, 
  });

  lenis.on("scroll", (e) => {
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  window.lenis = lenis;

  if (window.location.hash === "#contact_form") {
    const cta = document.querySelector(".call-to-action");
    const header = document.querySelector(".header");
    if (cta && header) {
      setTimeout(() => {
        lenis.scrollTo(cta.offsetTop - header.offsetHeight);
      }, 500);
    }
  }
},
  };

  document.addEventListener("DOMContentLoaded", () => {
const wowoEls = document.querySelectorAll(".wowo");
wowoEls.forEach((el) => wowoObserver.observe(el));
    // AppFunctions.lenisFun();
    AppFunctions.marquee();
    AppFunctions.click();
    AppFunctions.swiper();
    AppFunctions.simpleBar();
    AppFunctions.resizeWindow();
    AppFunctions.UpdateQuickAdd();
    AppFunctions.scroll();

    window.addEventListener("load", () => {
      setTimeout(() => {
        AppFunctions.insertElement();
      }, 500);
    });
  
    window.addEventListener(
      "resize",
      debounce(() => {
        AppFunctions.resizeWindow();
      })
    );
  });

  window.SlideAnim = SlideAnim;
  window.debounce = debounce;
  window.AppFunctions = AppFunctions;
